var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.objectUuid
    ? _c(
        "object-form-structure",
        {
          attrs: {
            title: _vm.getTitle(),
            layer: _vm.objectLayer,
            "sub-title": _vm.getValueInObject("ts_logical_type"),
            form: _vm.form,
            "object-uuid": _vm.objectUuid,
            "object-coordinate": _vm.searchObjectField(
              this.objectData,
              "geo_json"
            )
          },
          on: {
            close: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c(
            "v-expansion-panels",
            {
              attrs: { multiple: "", id: "form-fields", accordion: "" },
              model: {
                value: _vm.panel,
                callback: function($$v) {
                  _vm.panel = $$v
                },
                expression: "panel"
              }
            },
            _vm._l(_vm.form.tabs, function(tab) {
              return _vm.panelIsVisible(tab)
                ? _c(
                    "v-expansion-panel",
                    {
                      key: tab.code,
                      attrs: { disabled: _vm.panelIsDisable(tab) }
                    },
                    [
                      _c("v-expansion-panel-header", [
                        _vm._v(_vm._s(tab.label))
                      ]),
                      _vm._v(" "),
                      tab.type === "form"
                        ? _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-layout",
                                {
                                  staticClass: "mx-5 my-2",
                                  attrs: {
                                    wrap: "",
                                    "justify-space-between": ""
                                  }
                                },
                                _vm._l(tab.fields, function(field) {
                                  return _c("network-fields", {
                                    key: field.id,
                                    attrs: {
                                      label: field.label_client
                                        ? field.label_client
                                        : field.label,
                                      inputType: field.input_type,
                                      value: _vm.getValueInObject(
                                        field.var_name
                                      ),
                                      hide: field.hide,
                                      size: field.size,
                                      "variable-name": field.var_name,
                                      "select-options": field.select_list_name
                                    }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            }),
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-27cf66cd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27cf66cd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Network/Forms/ObjectForms/COAreaForm.vue
// module id = null
// module chunks = 